import { Component, ElementRef, Inject, Injector} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from '../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { YesNoModal } from "../yesno/yesno.component";


@Component({
    selector: "modal-yesno",
    template: require('./mobile-yesno.component.html'),
    styles: [require('./mobile-yesno.component.css')]
})

export class MobileYesNoModal  extends  YesNoModal {

    
    constructor(
        private _router: Router,
        private _fb: FormBuilder,
        public _activeModal: NgbActiveModal,
        private _dataService: DataService,
        injector: Injector,
      //  public orderDeleteData:deleteOrderRequest
    ) {

        super(_router, _fb, _activeModal, _dataService, injector)
    }

    get horizontal()
    {
        return this.workspace.horizontalMode;
    }

}

export function ShowMobileYesNoOrderModal(modalService: NgbModal){
    let m:NgbModalRef= modalService.open(MobileYesNoModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal mobile"
    });
    let modal = (<MobileYesNoModal>m.componentInstance);
    
    return modal

}
